import {PropsWithChildren, useContext} from "react";
import React from 'react';
import { useUserInfo } from "./useUserInfo";
import { UserContext } from "../context/userContext";

const URL_USER = "/wp-json/pg/v1/user/sawbanner"

export const useUser = () => useContext(UserContext);
export default function UserDataProvider({children}: PropsWithChildren<{}>) {
    
    const [isUserSawBanner,loadedUserInfo,setIsUserSawBanner] = useUserInfo(URL_USER)

    const value: {
        isUserSawBanner:boolean,
        loadedUserInfo:boolean,
        setIsUserSawBanner:(value: React.SetStateAction<boolean>) => void

    } = {
        loadedUserInfo,
        isUserSawBanner,
        setIsUserSawBanner
    }
    return (
        <UserContext.Provider value={value}>
            {children}
        </UserContext.Provider>
    )
}